import { Cookies } from 'react-cookie';

import { ObjectDocsApiResponse } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getObjectDocs = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/object-docs/${slug}/documents/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as ObjectDocsApiResponse;
};
